import { useState } from "react"
import PropTypes from "prop-types"
import { Box, Button, StackView } from "@planningcenter/tapestry-react"

const NewAssignmentType = ({ onCancel, onSave, saveLabel = "Save", saveButtonSize = "sm" }) => {
  const [name, setName] = useState("")
  const [validation, setValidation] = useState({})

  const validateForm = () => {
    let validation = {}

    if (name === null || name.trim() === "") {
      validation = { name: "Name can not be blank." }
    }

    setValidation(validation)
    return validation
  }

  const handleSave = () => {
    const validate = validateForm()
    if (validate.name) {
      return
    }

    return onSave({ name })
  }

  return (
    <Box>
      <StackView axis="horizontal" alignment="center" spacing={1}>
        <input
          className={`f-1 ${validation.name && "error-input"}`}
          type="text"
          name="name"
          placeholder="Cabins, teams, classes"
          value={name}
          onKeyUp={e => e.keyCode === 13 && handleSave()}
          onChange={e => setName(e.target.value)}
        />

        {onCancel && (
          <Button variant="outline" size="sm" onClick={() => onCancel()} title="Cancel" />
        )}
        <Button theme="create" size={saveButtonSize} onClick={handleSave} title={saveLabel} />
      </StackView>
      {validation.name && <div className="c-danger font-size-5">{validation.name}</div>}
    </Box>
  )
}

NewAssignmentType.propTypes = {
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  saveLabel: PropTypes.string,
  saveButtonSize: PropTypes.string
}

export default NewAssignmentType
